// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"App_appContainer__3jRx1","menuPlaceholder":"App_menuPlaceholder__2isd9"};